export class ArbetsorderPlaneringSchedulerTexts {
// eslint-disable-next-line sonarjs/public-static-readonly
    static texts = {
        schemalaggningUtanforAvverkningsanmalan: "Schemaläggning utanför avverkningsanmälan",
        schemalaggningUtanforDatumForCertifikatskontroll: "Schemaläggning utanför datum för certifikatskontroll"
    };
}
